import classNames from 'classnames'
import { type ReactNode, useState } from 'react'
import { type PopperProps } from '@mui/material/Popper'
import type { IDropdownItem, IDropdownProps } from 'shared/ui/Dropdown'
import { Dropdown } from 'shared/ui/Dropdown/ui/Dropdown'
import { type ILabel, Label } from 'shared/ui/Label'
import { Error } from 'shared/ui/Error'
import { type ZIndex } from 'shared/constants/zIndex'
import { type ITooltipProps, Tooltip } from 'shared/ui'
import { type ITextFieldPlaceholderProps, TextFieldPlaceholder } from '../../../TextField'
import styles from './styles.module.scss'

export interface IDropdownPlaceholderProps {
  items?: IDropdownItem[]
  onChange?: (item: IDropdownItem) => void
  widthDropdown?: number
  maxHeight?: number
  topListComponent?: IDropdownProps['topListComponent']
  textPlaceholderProps?: Omit<ITextFieldPlaceholderProps, 'placeholder'>
  placeholder?: ReactNode
  parentsDropdownId?: string[]
  onToggle?: (open: boolean) => void
  label?: ILabel
  additionalWidth?: number
  offset?: { x?: number; y?: number }
  customComponent?: IDropdownProps['customComponent']
  onChangeOpen?: IDropdownProps['onChangeOpen']
  zIndex?: ZIndex
  bottomActions?: IDropdownProps['bottomActions']
  error?: string | ReactNode
  show?: boolean
  triggerTooltipProps?: ITooltipProps
  PopperProps?: Partial<PopperProps>
  propsDropdownList?: IDropdownProps['propsDropdownList']
}

export const DropdownPlaceholder = ({
  items,
  onChange,
  widthDropdown,
  onToggle,
  maxHeight = 168,
  topListComponent,
  textPlaceholderProps,
  parentsDropdownId,
  placeholder,
  label,
  additionalWidth,
  offset,
  customComponent,
  onChangeOpen,
  bottomActions,
  zIndex,
  error,
  show,
  triggerTooltipProps,
  PopperProps,
  propsDropdownList,
}: IDropdownPlaceholderProps) => {
  const [ref, setRef] = useState<HTMLDivElement | null>(null)

  const triggerContent = (
    <TextFieldPlaceholder
      error={error}
      {...textPlaceholderProps}
      placeholder={placeholder || 'Select'}
    />
  )

  return (
    <>
      <div>
        <Label label={label} />
        <Dropdown
          show={show}
          ariaLabel={'DropdownPlaceholder'}
          items={items}
          onChange={onChange}
          parentsDropdownId={parentsDropdownId}
          maxHeight={maxHeight}
          margin={0}
          PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  offset: ({ reference }) => {
                    return [Number(offset?.x || 0), -reference.height + Number(offset?.y || 0)]
                  },
                },
              },
            ],
            ...PopperProps,
          }}
          className={classNames({
            [styles.error]: !!error,
          })}
          onToggle={onToggle}
          width={widthDropdown || Number(ref?.offsetWidth || 0) + Number(additionalWidth || 0)}
          tooltipProps={{
            label: 'sss',
          }}
          triggerComponent={() => (
            <div ref={setRef}>
              {triggerTooltipProps ? (
                <Tooltip {...triggerTooltipProps}>{triggerContent}</Tooltip>
              ) : (
                triggerContent
              )}
            </div>
          )}
          topListComponent={topListComponent}
          customComponent={customComponent}
          onChangeOpen={onChangeOpen}
          zIndex={zIndex}
          bottomActions={bottomActions}
          propsDropdownList={propsDropdownList}
        />
        <Error type={'text'} error={error} />
      </div>
    </>
  )
}
